import { Wrapper, ContentWrapper, Main } from "./HeroSectionElements";

const HeroSection = () => {
    return (
      <Wrapper>
        <ContentWrapper>
          <Main>Unsplash Image Search</Main>
        </ContentWrapper>
      </Wrapper>
    );
}

export default HeroSection
